import React, { useState, useEffect, useRef } from "react";
import { MainDiv, RamkaDiv } from "./styled";
import { useTranslation } from "react-i18next";
import img1 from "../../assets/images/IMG_1070.JPG";
import img2 from "../../assets/images/IMG_1082.JPG";
import img3 from "../../assets/images/IMG_1088.PNG";
export const DepartmentsScroll = () => {
  const [isDivOverFiftyPercent, setIsDivOverFiftyPercent] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);
  const divRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
  ];
  const { t } = useTranslation();
  const [value, setValue] = useState();
  const [lang, setLang] = useState();
  useEffect(() => {
    setLang(localStorage.getItem("lang"));
  }, [t]);
  useEffect(() => {
    const handleScroll = (index) => () => {
      if (divRefs[index].current) {
        const divBounding = divRefs[index].current.getBoundingClientRect();
        const windowHeight =
          window.innerHeight || document.documentElement.clientHeight;
        const divTop = divBounding.top;
        const divHeight = divBounding.height;
        const isOverHalfVisible =
          (divTop >= 0 && divTop < windowHeight / 1.5) ||
          (divTop < 0 && Math.abs(divTop) < divHeight / 1.5);

        setIsDivOverFiftyPercent((prevState) => {
          const newState = [...prevState];
          newState[index] = isOverHalfVisible;

          if (isOverHalfVisible) {
            newState.forEach((_, i) => {
              if (i !== index) newState[i] = false;
            });
          }

          return newState;
        });
      }
    };

    divRefs.forEach((ref, index) => {
      window.addEventListener("scroll", handleScroll(index));
    });

    return () => {
      divRefs.forEach((ref, index) => {
        window.removeEventListener("scroll", handleScroll(index));
      });
    };
  }, [divRefs]);

  const products = [
    {
      _id: {
        $oid: "676e7424fe3ae02e5164b12b",
      },
      textTitleAM: "Նկարիչի վարպետական հարվածը",
      textAM:
        "Կանաչ ներկի ուշադիր կատարած հպումը ցույց է տալիս նկարչի նվիրվածությունն ու իր գործի հանդեպ ճշգրտությունը:",
      textTitleRU: "Мастерский мазок художника",
      textRU:
        "Уверенная рука художника наносит точный мазок зелёной краски, воплощая концентрацию и мастерство.",
      textTitleEN: "The Artist's Masterful Stroke",
      textEN:
        "A meticulous green brushstroke reveals the artist’s dedication and precision in their work.",
      src: img2,
      activ: true,
      createdAt: {
        $date: "2024-12-27T09:32:20.065Z",
      },
      first: true,
      __v: 0,
    },
    {
      _id: {
        $oid: "676e7531fe3ae02e5164b16c",
      },
      textTitleAM: "Գույների եւ զգացմունքների պայծառ պալիտրա",
      textAM:
        "Վառ ներկապնակը և պրոֆեսիոնալ գործիքները ստեղծում են հենք մի ստեղծագործության, որը լի է գույնով և զգացմունքներով:",
      textTitleRU: "Яркая палитра эмоций",
      textRU:
        "Яркая палитра и профессиональные инструменты создают основу для произведения, насыщенного цветом и эмоциями.",
      textTitleEN: "A Vibrant Palette of Emotion",
      textEN:
        "A vibrant palette and professional tools set the stage for a masterpiece rich in color and emotion.",
      src: img1,
      activ: true,
      createdAt: {
        $date: "2024-12-27T09:36:49.855Z",
      },
      first: false,
      __v: 0,
    },
    {
      _id: {
        $oid: "676e7790fe3ae02e5164b1a6",
      },
      textTitleAM: "Քաոսի ներդաշնակությունը",
      textAM:
        "Գույների նուրբ համադրությունն ու գործիքների կարծես քաոսային դասավորությունը խոսում են վարպետի ստեղծագործական ոգեշնչման և հարուստ երևակայության մասին:",
      textTitleRU: "Гармония хаоса",
      textRU:
        "Изысканное сочетание красок и хаотично упорядоченные инструменты намекают на творческий порыв и богатство воображения мастера.",
      textTitleEN: "The Harmony of Chaos",
      textEN:
        "A refined mix of colors and a seemingly chaotic arrangement of tools hint at the creative spark and vivid imagination of the master.",
      src: img3,
      activ: true,
      createdAt: {
        $date: "2024-12-27T09:46:56.483Z",
      },
      first: true,
      __v: 0,
    },
  ];
  useState(() => {
    setValue(products);
  }, []);

  return (
    <MainDiv $isDivOverFiftyPercent={isDivOverFiftyPercent}>
      {value?.map((e, i) => {
        if (e.activ && lang == "ru") {
          return (
            <RamkaDiv
              key={i}
              ref={divRefs[i]}
              $isDivOverFiftyPercent={isDivOverFiftyPercent[i]}
              $first={e.first}
                $index={i}

            >
              <span>
                {e.textTitleRU.toUpperCase()} <p>{e.textRU.toUpperCase()}</p>
              </span>
              <img src={`${e.src}`} alt="paintings" />
            </RamkaDiv>
          );
        } else if (e.activ && lang == "en") {
          return (
            <RamkaDiv
              key={i}
              ref={divRefs[i]}
              $isDivOverFiftyPercent={isDivOverFiftyPercent[i]}
              $first={e.first}
                $index={i}

            >
              <span>
                {e.textTitleEN.toUpperCase()} <p>{e.textEN.toUpperCase()}</p>
              </span>
              <img src={`${e.src}`} alt="paintings" />
            </RamkaDiv>
          );
        } else if (e.activ && lang == "am") {
          return (
            <RamkaDiv
              key={i}
              ref={divRefs[i]}
              $isDivOverFiftyPercent={isDivOverFiftyPercent[i]}
              $first={e.first}
                $index={i}

            >
              <span>
                {e.textTitleAM.toUpperCase()} <p>{e.textAM.toUpperCase()}</p>
              </span>
              <img src={`${e.src}`} alt="paintings" />
            </RamkaDiv>
          );
        }
      })}
    </MainDiv>
  );
};
